import { AppText } from '@/components';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

export const Username = ({ userId, name, className = '', isLocal, prefix = '', maxLength, ...rest }) => {
   const user = useSelector(state => state.userInfoData?.users[userId]);
   const displayName = user?.nickName || name || user?.name || userId;

   const formatName = nameStr => {
      if (!maxLength || !nameStr || nameStr.length <= maxLength) return nameStr;
      return `${nameStr.substring(0, maxLength)}...`;
   };

   const finalDisplayName = isLocal ? 'You' : formatName(displayName);

   return (
      <AppText as="span" className={className} {...rest}>
         {prefix}
         {finalDisplayName}
      </AppText>
   );
};

Username.propTypes = {
   userId: PropTypes.string,
   name: PropTypes.string,
   className: PropTypes.string,
   isLocal: PropTypes.bool,
   prefix: PropTypes.string,
   maxLength: PropTypes.number,
};
